import 'dayjs/locale/fr';
import i18n from 'i18next';
import { getLocaleNamespaces } from './locales';

export const fetchNamespaces = (locale: string) => {
  return getLocaleNamespaces(locale);
};

export default i18n;
